import React, { Component, Fragment } from 'react';
import { Modal } from 'react-bootstrap';

class Example extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    }
  }
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });

  render() {
    const {descripcion} = this.props;
    const {text} = this.props;
    ////console.log(data);
    return (
      <Fragment>
        <p onClick={this.handleShow}>
          {text}
        </p>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>OBSERVACION COMPLETA</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {descripcion}
          </Modal.Body>
        </Modal>
      </Fragment>
    );
  }
}

export default Example;